'use strict';

var React = require('react');

var SvgPromoteMinor = function SvgPromoteMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-3.5h-2v3h-10v-10h3v-2h-3.5zm12.5 1a1 1 0 0 0-1-1h-5a1 1 0 1 0 0 2h2.586l-5.293 5.293a.999.999 0 1 0 1.414 1.414l5.293-5.293v2.586a1 1 0 1 0 2 0v-5z"
  }));
};

exports.SvgPromoteMinor = SvgPromoteMinor;
